export default __webpack_public_path__ + "static/media/16.0d05f95a.jpg";